/**
 * 俄语（ru-RU）
 */
export default {

}

